import { Collapse } from 'bootstrap';
export default class FormAccordionValidator {
    static mount() {
        document.addEventListener('DOMContentLoaded', () => {
            new FormAccordionValidator();
        });
    }
    constructor() {
        // Verwende die spezifische ID "formAccordion", um das richtige Formular zu finden
        const form = document.getElementById('formAccordion');
        if (!form) {
            return;
        }
        // Contact Form 7 Hook verwenden, um auf ungültige Felder zu reagieren
        document.addEventListener('wpcf7invalid', (event) => {
            // Verzögerung einbauen, um sicherzustellen, dass die Felder als ungültig markiert sind
            setTimeout(() => {
                // Versuch, alle Felder mit aria-invalid=true ODER der ungültigen Klasse zu finden
                const invalidFields = form.querySelectorAll('[aria-invalid="true"], .wpcf7-not-valid');
                if (invalidFields.length > 0) {
                    // Das erste ungültige Feld finden
                    const firstInvalidField = invalidFields[0];
                    // Manuelle Suche nach dem nächstgelegenen .accordion-item-Element
                    let parentAccordionItem = null;
                    let element = firstInvalidField;
                    // Suche nach dem parent .accordion-item, indem durch die Elternknoten navigiert wird
                    while (element && !parentAccordionItem) {
                        if (element.classList && element.classList.contains('accordion-item')) {
                            parentAccordionItem = element; // Setze das gefundene Accordion-Item
                        }
                        else {
                            element = element.parentElement; // Gehe eine Ebene höher
                        }
                    }
                    if (!parentAccordionItem) {
                        return; // Wenn kein passendes Accordion-Item gefunden wird, beenden
                    }
                    // Öffne das Accordion-Item, das das ungültige Feld enthält
                    const collapseToOpen = parentAccordionItem.querySelector('.accordion-collapse');
                    if (collapseToOpen) {
                        const bsCollapseToOpen = Collapse.getInstance(collapseToOpen) || new Collapse(collapseToOpen);
                        bsCollapseToOpen.show(); // Öffne das entsprechende Accordion
                    }
                    // Setze den Fokus auf das erste ungültige Feld
                    if (firstInvalidField) {
                        firstInvalidField.focus();
                    }
                }
            }, 100); // 100ms Verzgerung
        });
    }
}
